import { ClassList } from "./ClassList";
import { LayoutEntity } from "./Definitions";
import { MediaSpecific, mediaSpecificClass } from "./Media";
import css from "./Styles/width.module.scss";

export const enum Width
{
    WUnset,
    W1D12,
    W2D12,
    W3D12,
    W4D12,
    W5D12,
    W6D12,
    W7D12,
    W8D12,
    W9D12,
    W10D12,
    W11D12,
    W12D12,
    W20P,
    W39P,
    W40P,
    W45P,
    W50P,
    W55P,
    W60P,
    W61P,
    W80,
    W100P,
    W104,
    W112,
    W156,
    W168,
    W228,
    W244,
    W260,
    W270,
    W288,
    W300,
    W320,
    W332,
    W348,
    W352,
    W354,
    W358,
    W360,
    W364,
    W372,
    W378,
    W382,
    W386,
    W388,
    W394,
    W404,
    W414,
    W420,
    W424,
    W428,
    W436,
    W438,
    W444,
    W448,
    W454,
    W472,
    W480,
    W482,
    W486,
    W490,
    W506,
    W528,
    W532,
    W542,
    W560,
    W566,
    W572,
    W582,
    W594,
    W618,
    W636,
    W648,
    W674,
    W684,
    W708,
    W756,
    W774,
    W804,
    W912,
    W1038,
    W1044,
    W80P,
    W85P,
    W90P,
}

const widthClassMap: Record<Width, string> = {
    [Width.WUnset]: "unset",
    [Width.W1D12]: "1d12",
    [Width.W2D12]: "2d12",
    [Width.W3D12]: "3d12",
    [Width.W4D12]: "4d12",
    [Width.W5D12]: "5d12",
    [Width.W6D12]: "6d12",
    [Width.W7D12]: "7d12",
    [Width.W8D12]: "8d12",
    [Width.W9D12]: "9d12",
    [Width.W10D12]: "10d12",
    [Width.W11D12]: "11d12",
    [Width.W12D12]: "12d12",
    [Width.W20P]: "20p",
    [Width.W39P]: "39p",
    [Width.W40P]: "40p",
    [Width.W45P]: "45p",
    [Width.W50P]: "50p",
    [Width.W55P]: "55p",
    [Width.W60P]: "60p",
    [Width.W61P]: "61p",
    [Width.W80]: "80",
    [Width.W100P]: "100p",
    [Width.W104]: "104",
    [Width.W112]: "112",
    [Width.W156]: "156",
    [Width.W168]: "168",
    [Width.W228]: "228",
    [Width.W244]: "244",
    [Width.W260]: "260",
    [Width.W270]: "270",
    [Width.W288]: "288",
    [Width.W300]: "300",
    [Width.W320]: "320",
    [Width.W332]: "332",
    [Width.W348]: "348",
    [Width.W352]: "352",
    [Width.W354]: "354",
    [Width.W358]: "358",
    [Width.W360]: "360",
    [Width.W364]: "364",
    [Width.W372]: "372",
    [Width.W378]: "378",
    [Width.W382]: "382",
    [Width.W386]: "386",
    [Width.W388]: "388",
    [Width.W394]: "394",
    [Width.W404]: "404",
    [Width.W414]: "414",
    [Width.W420]: "420",
    [Width.W424]: "424",
    [Width.W428]: "428",
    [Width.W436]: "436",
    [Width.W438]: "438",
    [Width.W444]: "444",
    [Width.W448]: "448",
    [Width.W454]: "454",
    [Width.W472]: "472",
    [Width.W480]: "480",
    [Width.W482]: "482",
    [Width.W486]: "486",
    [Width.W490]: "490",
    [Width.W506]: "506",
    [Width.W528]: "528",
    [Width.W532]: "532",
    [Width.W542]: "542",
    [Width.W560]: "560",
    [Width.W566]: "566",
    [Width.W572]: "572",
    [Width.W582]: "582",
    [Width.W594]: "594",
    [Width.W618]: "618",
    [Width.W636]: "636",
    [Width.W648]: "648",
    [Width.W674]: "674",
    [Width.W684]: "684",
    [Width.W708]: "708",
    [Width.W756]: "756",
    [Width.W774]: "774",
    [Width.W804]: "804",
    [Width.W912]: "912",
    [Width.W1038]: "1038",
    [Width.W1044]: "1044",
    [Width.W80P]: "80p",
    [Width.W85P]: "85p",
    [Width.W90P]: "90p",
};

export type LayoutWidth = LayoutEntity<Width, "width">;
export type LayoutMaxWidth = LayoutEntity<Width, "maxWidth">;

export const widthClass = (width: Width | MediaSpecific<Width | LayoutWidth> | undefined): ClassList => mediaSpecificClass(width, "width", (width, suffix) => css[`w-${widthClassMap[width]}${suffix}`]);
export const maxWidthClass = (maxWidth: Width | MediaSpecific<Width | LayoutMaxWidth> | undefined): ClassList => mediaSpecificClass(maxWidth, "maxWidth", (maxWidth, suffix) => css[`mxw-${widthClassMap[maxWidth]}${suffix}`]);
export const maxWidthClassL = <LayoutKey extends string>(maxWidth: MediaSpecific<LayoutEntity<Width, LayoutKey>> | undefined, layoutKey: LayoutKey): ClassList => mediaSpecificClass(maxWidth, layoutKey, (maxWidth, suffix) => css[`mxw-${widthClassMap[maxWidth]}${suffix}`]);
